import { Download, FileText, ListOrdered, Table, Users } from "lucide-react";
import { API } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const ITEMS = [
  { k: "script.txt", label: "Script (.txt)", icon: FileText },
  { k: "scenes.txt", label: "Scene list (.txt)", icon: ListOrdered },
  { k: "scenes.csv", label: "Scene list (.csv spreadsheet)", icon: Table },
];

export const ExportMenu = ({ ep }) => (
  <DropdownMenu>
    <DropdownMenuTrigger data-testid="export-menu-btn" className="inline-flex items-center gap-1.5 px-3 h-8 rounded-full bg-[#212738] hover:bg-[#2A3245] text-xs transition-colors">
      <Download className="w-3.5 h-3.5" /><span className="hidden sm:inline">Downloads</span>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="bg-[#11141E] border-[#2A3245]">
      {ITEMS.map(({ k, label, icon: Icon }) => (
        <DropdownMenuItem key={k} asChild disabled={k === "script.txt" && !(ep.script || "").trim()}>
          <a data-testid={`export-${k.replace(".", "-")}`} href={`${API}/episodes/${ep.id}/export/${k}`}><Icon className="w-4 h-4 mr-2" />{label}</a>
        </DropdownMenuItem>
      ))}
      <DropdownMenuItem asChild>
        <a data-testid="export-cast-pack" href={`${API}/episodes/${ep.id}/cast-pack`}><Users className="w-4 h-4 mr-2" />Cast pack (photos + voices .zip)</a>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
